import React from "react";
import CBSLOGO from "../../cbs-logo-1.png";

function Header() {
  return (
    <div className="row">
      <div className="col-md-12 col-lg-12 col-12">
        <div className="text-center p-3">
          <img src={CBSLOGO} alt="logo" className="img-fluid"/>
        </div>
        <div className="header-content">
          <h3>CBS ACCIDENT DETAIL REQUEST FORM</h3>
          <p>
            Complete Billing Services, LLC | 517 US Highway 31 N. | Greenwood,
            IN 46142
          </p>
          <p>
            Toll Free Number: (888) 383-8025 | Email:
            Contact@CompleteBillingServices.biz
          </p>
        </div>
      </div>
    </div>
  );
}

export default Header;
